import { render, staticRenderFns } from "./LeonovFlooring.vue?vue&type=template&id=5699602a"
import script from "./LeonovFlooring.vue?vue&type=script&lang=js"
export * from "./LeonovFlooring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports